const MILE_IN_METERS = 1609.344;

export const metersToMiles = (meters: number): number => meters / MILE_IN_METERS;
